import type { ltFramework } from '@life-time-inc/enterprise-framework-core';
export const club: ltFramework.IClubDetailsFromDOM = window.lt.club;
